import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { WeatherSupportService } from '../../../../services/weather-support.service';
import { WeatherService } from '../../../../services/weather.service';
import { WeatherDescriptionIconNamePipe, WeatherDescriptionSimplifiedTextPipe, WeatherObservationWindGustsPipe } from '../../../weather-pipes';

@Component({
    selector: 'app-weather',
    imports: [
        CommonModule,
        RouterLink,
        MatButtonModule,
        MatCardModule,
        WeatherDescriptionIconNamePipe,
        WeatherDescriptionSimplifiedTextPipe,
        WeatherObservationWindGustsPipe
    ],
    templateUrl: './weather.component.html',
    styleUrls: ['./weather.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WeatherComponent {
  weatherService = inject(WeatherService);
  weatherSupportService = inject(WeatherSupportService);

  panelOpenState = false;

}
